const Advice = ({ content }) => (
  <div className="text-center mt-[24px] text-[28px] leading-[38px] tracking-[-0.3px] text-lightCyan">
    {content}
  </div>
);

export default Advice;
